module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/features/typography/table-without-border/table-without-border.component.scss
// module id = ./src/app/features/typography/table-without-border/table-without-border.component.scss
// module chunks = main